import React, { useEffect, useState } from 'react';
import useStateRef from "react-usestateref";
import Page from 'src/components/Page';
import './index.css';
import { LoadingView } from 'src/components/LoadingView';
// import axios from 'axios';

const TermsAndConditionPublicPage = () => {
  /* eslint-disable */
  const [initialized, setInitialized] = useState(false);
  const [loading, setLoading, loadingRef] = useStateRef(false);
  const [content, setContent, contentRef] = useStateRef("");
  /* eslint-enable */

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    if (!initialized) {
      setInitialized(true);
      // setLoading(true);
      // getData();
    }
  }, []);
  /* eslint-enable react-hooks/exhaustive-deps */

  // const getData = async () => {
  //   try {
  //     var hostname = window.location.origin;

  //     if(hostname){
  //       if(hostname.includes("localhost")){
  //         hostname = "cannatrek-patient.dynamicweb.net.au";
  //       }
  //     }
    
  //     await axios.get(`/dwapi/content/pages/url?url=/myeden/terms-and-conditions&hostname=${hostname}`, {
  //     }, {})
  //       .then(async response => {
  //         if (response) {
  //           if (response.data) {
  //             if (response.data.Item) {
  //               if (response.data.Item.Fields) {
  //                 var fields = response.data.Item.Fields;
  //                 fields.map((value) => {
  //                   if (value.Name === "Content") {
  //                     var new_content = value.Value.replace("{window.location.origin}", window.location.origin);
  //                     setContent(new_content);
  //                   }
  //                 })
  //               }
  //             }
  //           }
  //         }
  //       })
  //   } catch (e) {

  //   }
  //   setLoading(false);
  // }

  return (
    <Page title="Terms and Conditions" className="main-layout main-layout-public">
      {loadingRef.current ?
        <LoadingView />
        :
        <div className="main-wrapper-3">
          <div className="main-wrapper-padding">
            <div className="top-wrapper-title-2">Terms and Conditions of Use of greenship pharmacy</div>
            <div className="main-wrapper-content-description">
              <div className="terms_and_conditions_container">
                <div dangerouslySetInnerHTML={{ __html: contentRef.current }} />
              </div>
            </div>
          </div>
        </div>
      }
    </Page >
  )
}

export default TermsAndConditionPublicPage;